import { render, staticRenderFns } from "./AssetInformationComment.vue?vue&type=template&id=15b056ca&scoped=true&"
import script from "./AssetInformationComment.vue?vue&type=script&lang=js&"
export * from "./AssetInformationComment.vue?vue&type=script&lang=js&"
import style0 from "./AssetInformationComment.vue?vue&type=style&index=0&id=15b056ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b056ca",
  null
  
)

export default component.exports